import React from 'react';
import { connect } from 'react-redux';
import { Col, Row, Typography, Layout } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import TramittaLogo from '../images/tramitta-logo.png';
import LegalChileLogo from '../images/legalchile.svg';
import YapoLogo from '../images/yapo_logo.png';
import { EXTERNAL_URL } from '../config/constants/urls';
import PropTypes from 'prop-types';

const { Title } = Typography;
const { Header, Content } = Layout;

const FailAccess = ({ sourceUrl }) => {
  return (
    <React.Fragment>
      <Header className="header-container">
        <Row className="header-logos mb-0">
          <img src={LegalChileLogo} alt="" className="legal-logo" />
          {sourceUrl === EXTERNAL_URL.YAPO &&
            <img src={YapoLogo} alt="" className="yapo-logo" />
          }
          <img src={TramittaLogo} alt="" className="tramitta-logo" />
        </Row>
      </Header>
      <Content className="ant-layout-content-custom">
        <div className="text-center">
          <Row className="mb-4">
            <Col md={12} className="mx-auto">
              <ExclamationCircleOutlined style={{ fontSize: '56px', color: '#42EDBA' }} className="mb-4" />
              <Title level={2}>Este link no es válido</Title>
            </Col>
          </Row>
        </div>
      </Content>
    </React.Fragment>
  );
};

FailAccess.propTypes = {
  sourceUrl: PropTypes.string.isRequired,
};

const data = (state) => ({
  sourceUrl: state.contract.sourceUrl
});

export default connect(data, null)(FailAccess);